import { IconButton } from "@mui/material";
import { Box, styled } from "@mui/system";

export const PopupHeader = styled(Box)({
  padding: "10px",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  //background: "#ccd0e8",
  position: "sticky",
  top: "0",
  zIndex: 1,
  "& h2 ": {
    marginBottom: "0",
  },
});
export const PopupBody = styled(Box)({
  padding: " 20px 20px 20px 20px",
  width: "100%",
  height: "100%",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  "&:focus-visible ": {
    outline: "none",
  },
});
export const PopupButton = styled(IconButton)({
  minWidth: "24px",
  width: "24px",
  height: "24px",
  borderRadius: "50%",
  backgroundColor: "rgba(255, 255, 255, 0.5)",
  "& svg": {
    width: "12px",
    height: "12px",
  },
});
export const Fragment = styled(Box)({
  backgroundColor: "#fff",
  borderRadius: "6px",
  maxHeight: "calc(100vh - 40px)",
  maxWidth: "calc(100vw - 40px)",
  width: "fit-content",
  height: "fit-content",
  overflowY: "auto",
});
